// extracted by mini-css-extract-plugin
module.exports = {"component":"Toolbar_component__1h92s","button":"Toolbar_button__37fda","delete":"Toolbar_delete__VAzG5","viewIcon":"Toolbar_viewIcon__jE8RF","center":"Toolbar_center__d7HAz"};